// apps/web/src/lib/vendas/permissao.ts — Fase 12, WR-D1-07 (D1) / IN-D2-07.
// Regra pura da guarda de permissão das rotas de escrita de Vendas. O servidor continua sendo a barreira real (403); a guarda só
// evita que o usuário preencha o formulário inteiro (ou envie uma planilha de 10 MB) para descobrir que não pode.
import type { ObterSessaoResult } from '../session';

/** Permissão exigida por rota de Vendas que só faz sentido para quem escreve. */
export const PERMISSAO_ROTA_VENDAS: Readonly<Record<string, string>> = {
  '/vendas/pedidos/novo': 'pv:editar',
  '/vendas/pedidos/importar': 'pv:editar',
  '/vendas/precos': 'precos:gerenciar',
};

export type AcessoRota = 'permitido' | 'negado';

/**
 * Decide o acesso pela sessão. Sessão não autenticada (401/rede) NÃO é "negado": o AppShell cuida do redirecionamento ao login
 * e a API responde 401/403 de qualquer forma; bloquear aqui esconderia a tela de login.
 */
export function acessoDaRota(sessao: ObterSessaoResult, permissao: string): AcessoRota {
  if (!sessao.autenticado) return 'permitido';
  return sessao.usuario.permissions.includes(permissao) ? 'permitido' : 'negado';
}

export const MENSAGEM_SEM_PERMISSAO_ROTA = 'Você não tem permissão para acessar esta tela. Peça acesso a um administrador.';
